import { render, staticRenderFns } from "./Cash.vue?vue&type=template&id=8f923a4c&scoped=true&"
import script from "./Cash.vue?vue&type=script&lang=js&"
export * from "./Cash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f923a4c",
  null
  
)

export default component.exports